class Magazine {
    constructor() {

        // Force download file
        window.onload = () => {

            if (window.location.pathname.split('/').pop() === 'magazine_download') {
                window.location.href = '/download_magazine/';
            }

        };

        // Manual download button
        document.querySelector('#magazine_download')?.addEventListener('click', () => {
            window.location.href = '/download_magazine/';
        });

    }
}

new Magazine();